// extracted by mini-css-extract-plugin
export var open = "Collapsible-module--open--ac003";
export var wrapper = "Collapsible-module--wrapper--dc832";